class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = (this.querySelector('input[name="discount"]').value || '').trim();
      if (!this.val) return;
      localStorage.setItem('storedDiscount', this.val);
      // permite reprocessar um código digitado manualmente (limpa o anti-loop)
      sessionStorage.removeItem('discountTried_' + this.val);
      fetch(`/discount/${encodeURIComponent(this.val)}`)
        .then((response) => response.text())
        .then(() => {
          // recarrega o carrinho lateral pra refletir o total já com desconto
          if (window.Shopify && window.halo && typeof halo.updateSidebarCart === 'function') {
            Shopify.getCart((cart) => halo.updateSidebarCart(cart));
          }
        });
      const openPopup = document.querySelector('.popup-toolDown.show');
      if (openPopup) openPopup.classList.remove('show');
      const preview = document.querySelector('.previewCart');
      if (preview) preview.classList.remove('active-tool');
    })
  }
}

customElements.define('coupon-code', CouponCode);

// ── Cupom automático no carrinho lateral ──
// Reaplica o cupom guardado em localStorage (ex.: quem chegou por
// /discount/VOLTEI10) e recarrega o drawer pra mostrar o total já com
// desconto + a linha do cupom, espelhando o checkout.
(function () {
  function refreshSidebar() {
    if (window.Shopify && window.halo && typeof halo.updateSidebarCart === 'function') {
      Shopify.getCart((cart) => halo.updateSidebarCart(cart));
    }
  }

  async function ensureStoredDiscountApplied() {
    const code = localStorage.getItem('storedDiscount');
    if (!code) return;

    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();

      // já refletido no carrinho? nada a fazer
      if ((cart.cart_level_discount_applications || []).length > 0) return;
      // carrinho vazio ainda: tenta de novo quando um item for adicionado
      if (!cart.item_count) return;

      // anti-loop: tenta no máximo uma vez por código por sessão
      const guard = 'discountTried_' + code;
      if (sessionStorage.getItem(guard)) return;
      sessionStorage.setItem(guard, '1');

      await fetch('/discount/' + encodeURIComponent(code));
      refreshSidebar();
    } catch (e) {
      /* silencioso — não quebra o carrinho se algo falhar */
    }
  }

  document.addEventListener('DOMContentLoaded', ensureStoredDiscountApplied);
  // toda vez que o drawer re-renderiza (ex.: item adicionado), reconfere
  document.addEventListener('cart-update', ensureStoredDiscountApplied);
})();